var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { BarChart, CartesianGrid, XAxis, YAxis, ResponsiveContainer, Bar } from "recharts";
import styled from "styled-components";
import moment from "moment";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import Button from "@irati/ui/src/Button";
import { perkbox } from "@irati/ui/src/global/colors";
import Select from "@irati/ui/src/FormItem/Select";
import { Hr } from "@irati/ui/src/Layout";
import { H3, H4 } from "@irati/ui/src/Headings";
import History from "@irati/utils/history";
import { injectIntl } from "@irati/utils/lang";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import authentication from "@irati/auth";
import getWalletBalances from "@irati/wallet/apollo/query/WalletBalances";
import getWalletBalance from "@irati/wallet/apollo/query/WalletBalance";
import { Lato } from "@irati/ui/src/global/fonts";
import ActivityItem from "../../../components/ReportingV2/DataItem";
var StyledResponsiveContainer = styled(ResponsiveContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .recharts-surface {\n    overflow: visible;\n    font-family: ", ";\n  }\n"], ["\n  .recharts-surface {\n    overflow: visible;\n    font-family: ", ";\n  }\n"])), Lato);
var Flex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n"])));
var Balances = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 30px;\n"], ["\n  display: flex;\n  margin-bottom: 30px;\n"])));
var SelectWidth = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 200px;\n  margin-right: -15px;\n  .Select-value-label,\n  .Select-option {\n    font-size: 12px;\n  }\n"], ["\n  width: 200px;\n  margin-right: -15px;\n  .Select-value-label,\n  .Select-option {\n    font-size: 12px;\n  }\n"])));
var DAY = "days";
var WEEK = "weeks";
var MONTH = "months";
var LAST_WEEK = "Last week";
var Wallet = /** @class */ (function (_super) {
    __extends(Wallet, _super);
    function Wallet(props) {
        var _this = _super.call(this, props) || this;
        _this.getWalletBalances = function (dateValue, dateType) {
            if (dateValue === void 0) { dateValue = 7; }
            if (dateType === void 0) { dateType = DAY; }
            var auth = _this.props.auth;
            var variables = {
                currency: authentication.defaultUserCurrency(),
                walletType: _this.props.walletType,
                dateValue: dateValue,
                dateType: dateType,
                tenantId: auth.business.uuid
            };
            return getWalletBalances(variables).then(function (res) {
                var balances = res.getWalletBalancesFromTime.balances.map(function (walletBalanceFromTime) {
                    return {
                        time: moment(walletBalanceFromTime.time).format("DD/MM/YYYY"),
                        balance: walletBalanceFromTime.balance
                    };
                });
                _this.setState({ balances: balances });
            });
        };
        _this.buildOptions = function () {
            var formatMessage = _this.props.formatMessage;
            return [
                {
                    value: LAST_WEEK,
                    label: formatMessage({ id: "admin.reportingV2.wallet.allWallets.filter.lastWeek" }),
                    data: { number: 7, type: DAY }
                },
                {
                    value: "Last 2 weeks",
                    label: formatMessage({ id: "admin.reportingV2.wallet.allWallets.filter.last2Weeks" }),
                    data: { number: 14, type: DAY }
                },
                {
                    value: "Last 1 month",
                    label: formatMessage({ id: "admin.reportingV2.wallet.allWallets.filter.lastMonth" }),
                    data: { number: 4, type: WEEK }
                },
                {
                    value: "Last 3 months",
                    label: formatMessage({ id: "admin.reportingV2.wallet.allWallets.filter.last3Months" }),
                    data: { number: 12, type: WEEK }
                },
                {
                    value: "Last 6 months",
                    label: formatMessage({ id: "admin.reportingV2.wallet.allWallets.filter.last6Months" }),
                    data: { number: 6, type: MONTH }
                },
                {
                    value: "Last 12 months",
                    label: formatMessage({ id: "admin.reportingV2.wallet.allWallets.filter.last12Months" }),
                    data: { number: 12, type: MONTH }
                }
            ];
        };
        _this.viewTransactions = function () {
            var route = _this.props.route;
            History.push("/reporting-v2/wallets/" + route, _this.context);
        };
        _this.updateFilter = function (value) {
            var filterOption = _this.buildOptions().find(function (option) { return option.value === value; });
            _this.setState({ filter: value, load: _this.getWalletBalances(filterOption.data.number, filterOption.data.type) });
        };
        var auth = _this.props.auth;
        var variables = {
            tenantId: auth.business.uuid,
            currency: authentication.defaultUserCurrency(),
            walletType: props.walletType
        };
        _this.state = {
            filter: LAST_WEEK,
            load: _this.getWalletBalances(),
            balances: null,
            availableBalance: null
        };
        getWalletBalance(variables).then(function (res) { return _this.setState({ availableBalance: res.getWalletBalanceAtTime.value }); });
        return _this;
    }
    Wallet.prototype.render = function () {
        var _a = this.state, filter = _a.filter, balances = _a.balances, availableBalance = _a.availableBalance;
        var _b = this.props, formatMessage = _b.formatMessage, title = _b.title, pending = _b.pending, availableBalanceTooltip = _b.availableBalanceTooltip;
        var currency = authentication.defaultUserCurrency();
        var formatter = function (value) { return formatCurrency({ isCents: false, value: value, currencyCode: currency }); };
        return (React.createElement(React.Fragment, null,
            React.createElement(Hr, { large: true, solid: true }),
            React.createElement(Flex, null,
                React.createElement(H3, null, formatMessage({ id: "admin.reportingV2.wallet.allWallets.title" }, { title: title })),
                React.createElement(Button, { primary: true, onClick: this.viewTransactions }, formatMessage({ id: "admin.reportingV2.wallet.allWallets.button" }))),
            React.createElement(Balances, null,
                !!availableBalance && (React.createElement(ActivityItem, { large: true, dataItem: availableBalance, label: "" + formatMessage({ id: "admin.reportingV2.wallet.availableBalance.label" }), toolTipText: availableBalanceTooltip, bold: true, currency: currency })),
                !!pending && (React.createElement(ActivityItem, { dataItem: pending, label: formatMessage({ id: "admin.reportingV2.wallet.pendingBalance.label" }), toolTipText: formatMessage({ id: "admin.reportingV2.wallet.pendingBalance.tooltip" }), bold: true, currency: currency, isCents: false }))),
            React.createElement(Flex, null,
                React.createElement(H4, null, formatMessage({ id: "admin.reportingV2.wallet.allWallets.barChartHeader" })),
                React.createElement(SelectWidth, null,
                    React.createElement(Select, { name: "filter", label: "", options: this.buildOptions(), value: filter, onChange: this.updateFilter, isClearable: false }))),
            React.createElement(StyledResponsiveContainer, { height: 400 },
                React.createElement(BarChart, { data: balances },
                    React.createElement(CartesianGrid, { vertical: false }),
                    React.createElement(XAxis, { dataKey: "time", tickSize: 12, tickLine: false }),
                    React.createElement(YAxis, { tickFormatter: formatter, tickSize: 8, tickLine: false, axisLine: false }),
                    React.createElement(Bar, { dataKey: "balance", fill: perkbox.blue })))));
    };
    Wallet.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return Wallet;
}(Component));
export default injectIntl(withAuth(Wallet));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
